import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Container } from "semantic-ui-react";
import MobileNavigation from "../MobileNavigation/MobileNavigation";
import { useIntl, defineMessages } from "react-intl";
import config from "@plone/volto/registry";
import cx from "classnames";
import { flattenToAppURL } from "@plone/volto/helpers/Url/Url";

import Anontools from "@plone/volto/components/theme/Anontools/Anontools";
import LanguageSelector from "@plone/volto/components/theme/LanguageSelector/LanguageSelector";
import Logo from "@plone/volto/components/theme/Logo/Logo";
import Navigation from "@plone/volto/components/theme/Navigation/Navigation";
import SearchWidget from "@plone/volto/components/theme/SearchWidget/SearchWidget";
import UniversalLink from "@plone/volto/components/manage/UniversalLink/UniversalLink";
import SlotRenderer from "@plone/volto/components/theme/SlotRenderer/SlotRenderer";

import UwcLogo from "../../../../../assets/uwc-logo.png";

const messages = defineMessages({
  siteLabel: {
    id: "siteLabel",
    defaultMessage: " ",
  },
});

const Header = (props) => {
  const { pathname } = props;
  let siteLabel = config.settings.siteLabel;
  const token = useSelector((state) => state.userSession.token);
  const content = useSelector((state) => state.content.data);
  const siteAction = useSelector(
    (state) => state.content.data?.["@components"]?.actions?.site_actions,
  );
  const navRoot = useSelector((state) => state.navroot?.data?.navroot);
  const intl = useIntl();
  const translatedSiteLabel = intl.formatMessage(messages.siteLabel);

  siteLabel =
    siteLabel &&
    (translatedSiteLabel !== "siteLabel" && translatedSiteLabel !== " "
      ? translatedSiteLabel
      : siteLabel);

  return (
    <>
      <SlotRenderer name="aboveHeader" content={content} navRoot={navRoot} />
      <header className="header-wrapper">
        <Container>
          <div className="header">
            <div className="tools-wrapper">
              <LanguageSelector />
              <div className="tools">
                {!token && <Anontools />}
                {siteAction &&
                  siteAction.map((item) => (
                    <UniversalLink key={item.url} href={item.url}>
                      {item.title}
                    </UniversalLink>
                  ))}
              </div>
              {siteLabel && (
                <div className="intranet">
                  <p>{siteLabel}</p>
                </div>
              )}
            </div>
            <div className="logo-nav-wrapper">
              <div className="logo">
                <Logo />
              </div>
              <div className="nav-search-wrapper">
                <Navigation pathname={pathname} />
                <div className="search-wrapper navigation-desktop">
                  <div className="search">
                    <SearchWidget />
                  </div>
                </div>
              </div>
              <div className="wits-logo-wrapper">
                <a
                  href="https://www.uwc.ac.za/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={UwcLogo} alt="University of the Western Cape" />
                </a>
              </div>
              <MobileNavigation pathname={pathname} />
            </div>
          </div>
        </Container>
      </header>
    </>
  );
};

Header.propTypes = {
  token: PropTypes.string,
  pathname: PropTypes.string.isRequired,
};

Header.defaultProps = {
  token: null,
};

export default Header;
